import { useInfiniteQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { createApiClient } from "@/config/createApiClient";
import { selectedClientServiceIdAtom } from "@/store";

import { WorklistApi } from "../../config/apiClient";

const apiClient = createApiClient(WorklistApi);

export const useWorklist = () => {
  const useGetInfiniteWorklist = () => {
    const selectedClientServiceIdAtomValue = useAtomValue(
      selectedClientServiceIdAtom
    );

    return useInfiniteQuery({
      queryKey: ["worklist", selectedClientServiceIdAtomValue],
      queryFn: ({ pageParam }) =>
        apiClient.worklistsControllerGetWorklist({
          clientServiceId: selectedClientServiceIdAtomValue,
          limit: 10,
          page: pageParam,
        }),
      getNextPageParam: (lastPage) => {
        return (
          Number.parseInt(
            lastPage.data?.page ? `${lastPage.data?.page}` : "0",
            10
          ) + 1
        );
      },
      initialPageParam: 1,
      enabled: selectedClientServiceIdAtomValue > 0,
    });
  };

  return {
    useGetInfiniteWorklist,
  };
};
